var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "mt-1": "", "p-0": "", color: "primary" } },
    [
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _vm.title
            ? _c(
                "v-toolbar",
                { attrs: { width: "100%" } },
                [
                  _c(
                    "v-toolbar-title",
                    { staticClass: "heading landing-news-title" },
                    [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.title ? _c("v-divider") : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            {
              staticClass: "landing-posts-container",
              class: {
                column: _vm.$vuetify.breakpoint.mdAndDown,
                row: _vm.$vuetify.breakpoint.lgAndUp,
              },
              attrs: { wrap: "", "justify-center": "" },
            },
            [
              _vm._l(_vm.posts[_vm.page], function (post) {
                return _c(
                  "v-flex",
                  {
                    key: post.slug,
                    class: {
                      lg7:
                        _vm.$vuetify.breakpoint.lgAndUp &&
                        _vm.posts[_vm.page].length === 1,
                      lg4: _vm.posts[_vm.page].length > 1,
                    },
                    attrs: {
                      tabindex: "0",
                      role: "button",
                      "aria-label": "Open post titled " + post.title,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.showDialog(post.slug)
                      },
                      keydown: [
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.showDialog(post.slug)
                        },
                        function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "space", 32, $event.key, [
                              " ",
                              "Spacebar",
                            ])
                          ) {
                            return null
                          }
                          $event.preventDefault()
                          return _vm.showDialog(post.slug)
                        },
                      ],
                    },
                  },
                  [
                    _c(
                      "v-card",
                      {
                        staticClass: "landing-post",
                        attrs: {
                          elevation: "1",
                          ripple: true,
                          color: "primary",
                        },
                      },
                      [
                        post.full_picture
                          ? _c("v-img", {
                              attrs: {
                                src: post.full_picture,
                                alt: "Image for post titled " + post.title,
                                position: "top center",
                                height: "100px",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "v-card-title",
                          { staticClass: "landing-post-title" },
                          [
                            _c("div", [
                              _c("div", {
                                staticClass: "h6 font-weight-light p-1",
                                domProps: { innerHTML: _vm._s(post.title) },
                              }),
                              _vm._v(" "),
                              _c(
                                "a",
                                { attrs: { href: _vm.toPostLink(post.slug) } },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "grey--text text-subtitle-2",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(post.date) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.posts.length && !_vm.isLoading
                ? _c(
                    "v-layout",
                    {
                      attrs: {
                        "pt-5": "",
                        "pb-8": "",
                        "text-center": "",
                        "full-width": "",
                        "justify-center": "",
                        tag: "nav",
                        "aria-label": "Posts Pagination",
                      },
                    },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "" } },
                        [
                          _c("v-pagination", {
                            attrs: {
                              length: _vm.posts.length - 1,
                              "total-visible": _vm.perPage - 1,
                              color: "accent",
                              "next-icon": "fad fa-chevron-right",
                              "prev-icon": "fad fa-chevron-left",
                              "aria-label": "Pagination navigation",
                            },
                            model: {
                              value: _vm.page,
                              callback: function ($$v) {
                                _vm.page = $$v
                              },
                              expression: "page",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLoading
                ? _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm12: "",
                        md12: "",
                        lg6: "",
                        "pt-8": "",
                        "pb-8": "",
                        "full-width": "",
                        "align-middle": "",
                        "justify-middle": "",
                        "text-center": "",
                        column: "",
                      },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            "aria-label": "Loading",
                            role: "progressbar",
                            icon: "",
                            large: "",
                            disabled: "",
                          },
                        },
                        [_c("v-icon", [_vm._v("fal fa-circle-notch fa-spin")])],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.posts.length === 0 && !_vm.isLoading
                ? _c(
                    "v-flex",
                    {
                      attrs: {
                        xs12: "",
                        sm12: "",
                        md12: "",
                        lg11: "",
                        "pt-8": "",
                        "pb-8": "",
                        "full-width": "",
                        "align-middle": "",
                        "justify-middle": "",
                        "text-center": "",
                        column: "",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        { attrs: { elevation: "1", color: "primary" } },
                        [
                          _c("v-card-text", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("components.posts.noPosts")) +
                                "\n          "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }